const Education=()=>(
    <div className="tab-contents" id="education">
                <ul>
                  <li>
                    <span>2020</span>
                    <br />
                    Starting a bachelor degree at Al Akhawayn University in Morocco.
                  </li>
                  {/* <li>
                    <span>2024</span>
                    <br />
                    Internship
                  </li> */}
                  {/* <li>
                    <span>2025</span>
                    <br />
                    Graduation
                  </li> */}
                  <li>
                    <span>2023</span>
                    <br />
                    Exchange semester at Agnes Scott College in USA for a minor in Mathematics.{" "}
                    
                  </li>
                </ul>
              </div>
)
export default Education;